import React from 'react'
import PropTypes from 'prop-types'
import CorporateHeader from './header'
import Footer from './footer'
import Payment from './payment'
import Members from './members'

const Corporate = ({
  id,
  title,
  status,
  location,
  locationSlug,
  noOfPasses,
  startDate,
  endDate,
  invitedMembers,
  isRecurrent,
  nextBill,
  price,
  user_id,
}) => (
  <div className="w-full md:w-1/2">
    <div className="shadow-md bg-white m-5 p-5">
      <CorporateHeader
        title={title}
        status={status}
        location={location}
        noOfPasses={noOfPasses}
        startDate={startDate}
        endDate={endDate}
      />
      <div className="mt-10">
        <div className="flex flex-col justify-center items-center">
          {status === 'active' && <Payment title={title} isRecurrent={isRecurrent} nextBill={nextBill} price={price}/>}
          {status !== 'expired' &&
          <a className={`flex font-semibold justify-center w-3/4 py-3 rounded-lg text-sm bg-primary-orange text-white`}
            href={`/passport-listing/${locationSlug}`}>
            Book a Space
          </a>}
          {status === 'expired' && <a href={`/client/passport/pay/corporate/${locationSlug}`}
            className={`flex font-semibold justify-center w-3/4 py-3 rounded-lg text-sm bg-primary-orange text-white`}>
            Purchase Plan
          </a>}
          <Footer status={status} locationSlug={locationSlug} id={id}/>
        </div>
      </div>
    </div>
    {status === 'active' && <Members invitedMembers={invitedMembers} user_id={user_id}/>}
  </div>
)

Corporate.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  locationSlug: PropTypes.string.isRequired,
  noOfPasses: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  invitedMembers: PropTypes.array,
  endDate: PropTypes.string,
  isRecurrent: PropTypes.bool,
  nextBill: PropTypes.string,
  price: PropTypes.string.isRequired,
  user_id: PropTypes.number.isRequired,
}

export default Corporate
